module.exports = __webpack_public_path__ + "static/img/West-Coast-Eagles.058b6f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/West-Coast-Eagles.jpg
// module id = LoDH
// module chunks = 1